// extracted by mini-css-extract-plugin
export default {"tags-container":"styles_tags-container__3O4Ou"};